export default __webpack_public_path__ + "static/media/public_demand_bg.d594cd65.jpg";